import React, { useEffect, useState } from "react";
import {
  Box,
  SimpleGrid,
  Icon,
  useToast,
  useColorModeValue,
} from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { GetDashboardSummary, GetPast30DaysSummary } from "services/transactionService";
import { GetUserStat } from "services/userService";
import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import Revenue from "./components/Revenue";
import { checkprivileges } from "helpers/utils";

import {
  MdAttachMoney,
  MdBarChart
} from "react-icons/md";
import { FaUser } from "react-icons/fa";

export default function UserReports() {
  // Chakra Color Mode
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");

  const toast = useToast();
  const userState = useSelector((state) => state?.user?.value);
  const token = userState.hasOwnProperty("token") ? userState.token : null;
  const privileges = userState.hasOwnProperty("privileges") ? userState.privileges : [];
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [revenue, setRevenue] = useState(null);
  const [stat, setStat] = useState(null);
  const [userStat, setUserStat] = useState(null);

  const filter = {
    institutions: []
  }

  const getDashboardSummary = async () => {
    try {
      setLoading(true);
      const response = await GetDashboardSummary(filter, token);
      setLoading(false);
      if (response.error || !response.success) {
        toast({
          id: response.error ? response.error : (response.message ? response.message : "api-error"),
          title: response.error ? response.error : (response.message ? response.message : "An error occured"),
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (response.success) {
        setStat(response?.data);
        return;
      }
    } catch (error) {
      setLoading(false);
      toast({
        id: error.message || "api-error",
          title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
    }
  };

  const getPast30DaysSummary = async () => {
    try {
      setLoading(true);
      const response = await GetPast30DaysSummary(filter, token);
      setLoading(false);
      if (response.error || !response.success) {
        toast({
          id: response.error ? response.error : (response.message ? response.message : "api-error"),
          title: response.error ? response.error : (response.message ? response.message : "An error occured"),
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (response.success) {
        setCategories(response.data.days)
        setRevenue([
          {
            name: "Revenue",
            data: response.data.totalPlatformRevenue,
          },
          {
            name: "Verifications",
            data: response.data.count,
          }
        ])
        return;
      }
    } catch (error) {
      setLoading(false);
      toast({
        id: error.message || "api-error",
          title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
    }
  };


  const getUserStat = async () => {
    try {
      setLoading(true);
      const response = await GetUserStat(token);
      setLoading(false);
      if (response.error || !response.success) {
        toast({
          id: response.error ? response.error : (response.message ? response.message : "api-error"),
          title: response.error ? response.error : (response.message ? response.message : "An error occured"),
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (response.success) {
        setUserStat(response?.data);
        return;
      }
    } catch (error) {
      setLoading(false);
      toast({
        id: error.message || "api-error",
          title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    getDashboardSummary();
    getPast30DaysSummary();
    getUserStat();
  }, [])


  return (
    <Box mt={{ sm: "40px", md: "80px" }} width="100%" mb="70">
      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 3 }}
        gap='20px'
        mb='20px'>
        <MiniStatistics
          startContent={
            <IconBox
              w='56px'
              h='56px'
              bg={boxBg}
              icon={
                <Icon w='32px' h='32px' as={MdAttachMoney} color={brandColor} />
              }
            />
          }
          name='Total Revenue'
          value={stat && stat.totalAmount}
        />

       {
        checkprivileges(privileges, ["Admin"]) &&
        <>
        <MiniStatistics
          startContent={
            <IconBox
              w='56px'
              h='56px'
              bg={boxBg}
              icon={
                <Icon w='32px' h='32px' as={MdAttachMoney} color={brandColor} />
              }
            />
          }
          name='Total Platform Revenue'
          value={stat && stat.totalPlatformRevenue}
        />
      </>
       }

        <MiniStatistics
          startContent={
            <IconBox
              w='56px'
              h='56px'
              bg={boxBg}
              icon={
                <Icon w='32px' h='32px' as={MdBarChart} color={brandColor} />
              }
            />
          }
          name='Total Query Today'
          value={stat && stat.todayViews}
        />
        <MiniStatistics
          startContent={
            <IconBox
              w='56px'
              h='56px'
              bg={boxBg}
              icon={
                <Icon w='32px' h='32px' as={MdBarChart} color={brandColor} />
              }
            />
          }
          name='Today Downloads Today'
          value={stat && stat.totalDownloads}
        />
        <MiniStatistics
          startContent={
            <IconBox
              w='56px'
              h='56px'
              bg={boxBg}
              icon={
                <Icon w='32px' h='32px' as={MdAttachMoney} color={brandColor} />
              }
            />
          }
          name='Today Revenue'
          value={stat && (stat.todayViewCharges + stat.todayDownloadCharges)}
        />

{
        checkprivileges(privileges, ["Admin"]) &&
        <>
                <MiniStatistics
        startContent={
          <IconBox
            w='56px'
            h='56px'
            bg={boxBg}
            icon={
              <Icon w='32px' h='32px' as={FaUser} color={brandColor} />
            }
          />
        }
        name='Total P2P Users'
        value={userStat && userStat.p2pUsers}
      />
      <MiniStatistics
      startContent={
        <IconBox
          w='56px'
          h='56px'
          bg={boxBg}
          icon={
            <Icon w='32px' h='32px' as={FaUser} color={brandColor} />
          }
        />
      }
      name='Total Organization Signups'
      value={userStat && userStat.organizationUsers}
    /></>
       }
      </SimpleGrid>
      {revenue && <Revenue categories={categories} revenue={revenue} />}
    </Box>
  );
}
